export default ({ t, accountScopedRoute }) => ({
  name: 'Companies',
  label: t('SIDEBAR.COMPANIES'),
  icon: 'i-ph-buildings',
  children: [
    {
      name: 'All Companies',
      label: t('SIDEBAR.ALL_COMPANIES'),
      to: accountScopedRoute(
        'companies_dashboard_index',
        {},
        { page: 1, search: undefined }
      ),
      activeOn: ['companies_dashboard_index', 'companies_dashboard_show'],
    },
  ],
});
